// extracted by mini-css-extract-plugin
export var redoItem = "_oc-1";
export var redoTrigger = "_oc-0";